(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sn-video-widget"] && !Shopify.designMode) return;
  try {
    // No network library or storage in the storefront. Pixels receive consented events.
window.SNVideoMetrics = class {
  constructor(widget) {
    this.widget = widget;
    this.sent = new Set();
    this.ranges = [];
    this.previous = null;
    this.seeking = false;
    this.visible = false;
    let config = {};
    try { config = JSON.parse(widget.querySelector('.sn-metrics-config')?.textContent || '{}'); } catch {}
    this.base = {
      widget_product: widget.dataset.product,
      widget_origin: widget.instagram ? 'Instagram' : 'Shopify',
      widget_video: widget.instagram ? widget.instagramUrl.split('/').filter(Boolean).pop() : String(config.video || 'local'),
      widget_callout: (widget.callout.textContent || '').trim().slice(0, 45),
      widget_environment: config.role === 'main' ? 'production' : 'test',
      widget_version: '1'
    };
    this.observer = new IntersectionObserver(entries => {
      this.visible = entries[0]?.intersectionRatio >= .5;
      this.impression();
    }, { threshold: [.5] });
    this.observer.observe(widget.launch);
    widget.listen(document, 'visibilitychange', () => { this.previous = null; this.impression(); });
    widget.listen(document, 'visitorConsentCollected', () => {
      this.ranges = []; this.previous = null;
      this.impression();
    });
    widget.listen(document, 'shopifyCustomerPrivacyApiLoaded', () => this.impression());
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], () => this.impression());
    const video = widget.full;
    if (video) {
      widget.listen(video, 'playing', () => { this.impression(); this.emit('start', {}, true); });
      widget.listen(video, 'seeking', () => { this.seeking = true; this.previous = null; });
      widget.listen(video, 'seeked', () => { this.seeking = false; this.previous = null; });
      widget.listen(video, 'timeupdate', () => this.progress());
      widget.listen(video, 'ended', () => { this.progress(); this.emit('end', { widget_percent: this.percent() }, true); });
    }
    const external = widget.querySelector('.sn-instagram-link');
    if (external) widget.listen(external, 'click', () => this.emit('external'));
  }
  allowed() {
    return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  }
  emit(action, extra = {}, once = false) {
    if (!this.allowed() || (once && this.sent.has(action)) || !window.Shopify?.analytics?.publish) return false;
    try {
      const result = window.Shopify.analytics.publish('sn_widget:' + action, { ...this.base, ...extra });
      if (result === false) return false;
      if (once) this.sent.add(action);
      Promise.resolve(result).catch(() => {});
      return true;
    } catch { return false; }
  }
  impression() {
    if (this.visible && !this.widget.hidden && !document.hidden) this.emit('impression', {}, true);
  }
  open() { this.impression(); this.emit('open'); this.previous = null; }
  close() { this.emit('close', { widget_percent: this.widget.instagram ? undefined : this.percent() }); this.previous = null; }
  percent() {
    const duration = this.widget.full?.duration;
    if (!Number.isFinite(duration) || duration <= 0) return 0;
    return Math.min(100, Math.floor(this.ranges.reduce((sum, [a, b]) => sum + b - a, 0) / duration * 100));
  }
  progress() {
    const v = this.widget.full;
    if (!this.allowed() || !v || document.hidden || this.seeking || !this.widget.dialog.open || (v.paused && !v.ended)) { this.previous = null; return; }
    const time = v.currentTime;
    if (this.previous !== null && time > this.previous && time - this.previous <= 2) {
      const all = [...this.ranges, [this.previous, time]].sort((a, b) => a[0] - b[0]);
      this.ranges = [];
      for (const range of all) {
        const last = this.ranges[this.ranges.length - 1];
        if (last && range[0] <= last[1] + .05) last[1] = Math.max(last[1], range[1]);
        else this.ranges.push([...range]);
      }
      const percent = this.percent();
      for (const mark of [25, 50, 75]) if (percent >= mark) this.emit('progress_' + mark, { widget_percent: mark }, true);
      if (percent >= 95) this.emit('complete', { widget_percent: percent }, true);
    }
    this.previous = time;
  }
  destroy() { this.observer.disconnect(); }
};

if (!customElements.get('sn-video-widget')) {
  customElements.define('sn-video-widget', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.preview = this.querySelector('.sn-preview');
      this.full = this.querySelector('.sn-full');
      this.instagram = this.dataset.origin === 'Instagram';
      this.embedHost = this.querySelector('.sn-embed-host');
      this.instagramUrl = this.getInstagramUrl();
      if (this.instagram && !this.instagramUrl) return;
      this.dialog = this.querySelector('.sn-dialog');
      this.launch = this.querySelector('.sn-launch');
      this.error = this.querySelector('.sn-error');
      this.callout = this.querySelector('.sn-callout');
      this.metrics = new window.SNVideoMetrics(this);
      this.calloutObserver = new MutationObserver(() => this.fitCallout());
      this.calloutObserver.observe(this.callout, { childList: true, characterData: true, subtree: true });
      this.listen(window, 'resize', () => this.fitCallout());
      document.fonts?.ready.then(() => { if (this.isConnected) this.fitCallout(); });
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.key = 'sn-video-dismissed:' + this.dataset.product;
      try { if (sessionStorage.getItem(this.key) && !this.hasAttribute('data-demo')) return; } catch {}
      this.listen(this.launch, 'click', () => this.openVideo());
      this.listen(this.querySelector('.sn-dismiss'), 'click', () => this.dismiss());
      this.listen(this.querySelector('.sn-close'), 'click', () => this.dialog.close());
      this.listen(this.dialog, 'close', () => this.afterClose());
      this.listen(this.dialog, 'click', (event) => {
        const box = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) this.dialog.close();
      });
      if (this.full) this.listen(this.full, 'error', () => { this.error.hidden = false; });
      if (this.preview) {
        this.listen(this.preview, 'playing', () => this.preview.setAttribute('data-playing', ''));
        this.listen(this.preview, 'error', () => this.preview.removeAttribute('data-playing'));
      }
      this.listen(document, 'visibilitychange', () => {
        if (document.hidden) { this.preview?.pause(); this.full?.pause(); }
        else this.playPreview();
      });
      this.listen(this.motion, 'change', () => {
        if (this.motion.matches) { this.preview?.pause(); this.preview?.removeAttribute('data-playing'); }
        else this.playPreview();
      });
      const reveal = () => {
        this.timer = setTimeout(() => {
          if (!this.isConnected || this.dismissed) return;
          this.hidden = false;
          this.fitCallout();
          this.playPreview();
          this.metrics.impression();
        }, 700);
      };
      if (document.readyState === 'complete') reveal();
      else window.addEventListener('load', reveal, { once: true, signal: this.signal });
    }
    listen(target, name, handler) { target.addEventListener(name, handler, { signal: this.signal }); }
    getInstagramUrl() {
      if (!this.instagram) return null;
      try {
        const url = new URL(this.dataset.instagramUrl);
        if (url.protocol !== 'https:' || !['instagram.com', 'www.instagram.com'].includes(url.hostname) || url.username || url.password || url.port) return null;
        const match = url.pathname.match(/^\/(?:[A-Za-z0-9._]+\/)?(p|reel|tv)\/([A-Za-z0-9_-]+)\/?$/);
        return match ? `https://www.instagram.com/${match[1]}/${match[2]}/` : null;
      } catch { return null; }
    }
    fitCallout() {
      if (this.hidden || !this.callout) return;
      const label = this.callout;
      label.style.removeProperty('font-size');
      label.style.width = 'max-content';
      const style = getComputedStyle(label);
      const padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
      const available = Math.max(80, document.documentElement.clientWidth - parseFloat(getComputedStyle(this).right) - this.offsetWidth * .73 - 12);
      label.style.maxWidth = available + 'px';
      const fits = () => label.scrollHeight <= parseFloat(getComputedStyle(label).lineHeight) * 2 + padding + 1;
      let fontSize = parseFloat(style.fontSize);
      while (!fits() && fontSize > 10) {
        fontSize -= .5;
        label.style.fontSize = fontSize + 'px';
      }
      if (label.offsetWidth <= this.offsetWidth * .98 && fits()) return;
      const context = document.createElement('canvas').getContext('2d');
      context.font = getComputedStyle(label).font;
      const longest = Math.max(...label.textContent.trim().split(/\s+/).map(word => context.measureText(word).width));
      const horizontalPadding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      let lower = Math.min(available, Math.max(45, longest + horizontalPadding));
      let upper = Math.min(label.offsetWidth, available);
      while (upper - lower > 1) {
        const width = (lower + upper) / 2;
        label.style.width = width + 'px';
        if (fits()) upper = width;
        else lower = width;
      }
      label.style.width = Math.ceil(upper) + 'px';
    }
    loadVideo(video) {
      if (!video || video.dataset.loaded) return;
      const sources = [...video.querySelectorAll('source[data-src]')];
      const adaptive = sources.find(source => source.type === 'application/x-mpegURL' && video.canPlayType(source.type));
      const selected = adaptive || sources.find(source => video.canPlayType(source.type));
      if (!selected) return;
      video.src = selected.dataset.src;
      video.dataset.loaded = 'true';
      video.load();
    }
    playPreview() {
      if (!this.preview || this.hidden || document.hidden || this.dialog.open || this.motion.matches || this.connection?.saveData) return;
      this.loadVideo(this.preview);
      this.preview.play().catch(() => this.preview.removeAttribute('data-playing'));
    }
    openVideo() {
      this.metrics.open();
      this.preview?.pause();
      this.error.hidden = true;
      this.dialog.showModal();
      this.launch.setAttribute('aria-expanded', 'true');
      if (this.instagram) {
        this.dialog.classList.add('sn-dialog-instagram');
        const frame = document.createElement('iframe');
        frame.className = 'sn-embed';
        frame.title = this.embedHost.dataset.title;
        frame.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.src = this.instagramUrl + 'embed/';
        this.embedHost.replaceChildren(frame);
        this.querySelector('.sn-instagram-link').href = this.instagramUrl;
        return;
      }
      this.loadVideo(this.full);
      this.full.currentTime = 0;
      this.full.play().catch(() => {});
    }
    afterClose() {
      this.metrics.close();
      this.embedHost?.replaceChildren();
      if (this.full) {
        this.full.pause();
        this.full.removeAttribute('src');
        delete this.full.dataset.loaded;
        this.full.load();
      }
      this.launch.setAttribute('aria-expanded', 'false');
      if (!this.hidden) this.launch.focus({ preventScroll: true });
      this.playPreview();
    }
    dismiss() {
      this.metrics.emit('dismiss');
      this.dismissed = true;
      this.preview?.pause();
      if (this.preview) {
        this.preview.removeAttribute('src');
        delete this.preview.dataset.loaded;
        this.preview.load();
      }
      this.hidden = true;
      clearTimeout(this.timer);
      try { sessionStorage.setItem(this.key, '1'); } catch {}
    }
    disconnectedCallback() {
      this.metrics?.destroy();
      clearTimeout(this.timer);
      this.preview?.pause();
      this.full?.pause();
      this.embedHost?.replaceChildren();
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.calloutObserver?.disconnect();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
